import { render, staticRenderFns } from "./GiftsBox.vue?vue&type=template&id=f6fc41ae&scoped=true&"
import script from "./GiftsBox.vue?vue&type=script&lang=js&"
export * from "./GiftsBox.vue?vue&type=script&lang=js&"
import style0 from "./GiftsBox.vue?vue&type=style&index=0&id=f6fc41ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc41ae",
  null
  
)

export default component.exports